<div class="container login">
  <mat-card>
    <mat-card-title>LoginForm</mat-card-title>
    <mat-card-subtitle *ngIf="val" class="cred">Credentials are not valid</mat-card-subtitle>

    <mat-card-subtitle>Please Enter Your Login Credentials</mat-card-subtitle>

    <mat-card-content>

      <form [formGroup]="loginForm" (ngSubmit)="submit()">
        <mat-form-field class="example-full-width">
          <mat-label>UserName</mat-label>
          <input type="text" matInput formControlName="username">
          <mat-hint>Username is required!</mat-hint>
          <mat-error *ngIf="loginForm.get('username').errors">
            UserName is <strong>required</strong>
          </mat-error>
        </mat-form-field><br/>
        <mat-form-field>
          <mat-label>Password</mat-label>
          <input type="password" matInput formControlName="password">
          <mat-hint>Password is required!</mat-hint>
          <mat-error *ngIf="loginForm.get('password').errors">
            Password is <strong>required</strong>
          </mat-error>
        </mat-form-field><br/>
        <hr>
        <button type="submit" mat-stroked-button [disabled]="!loginForm.valid" class="m-2">Submit</button>
        <button type="reset" mat-stroked-button>Reset</button><br/>
        <a routerLink="/signup" mat-flat-button>Don't have a account</a>
      </form>
    </mat-card-content>

  </mat-card>

</div>
